import { NewDynamicTab } from "../../../components/Page";
import { RuvitalPowerProcurement } from "../../../config/DefaultDates";
import { RuvnlTitle } from "../components";
import { TabSwitcher } from "../Raj_Dashboard";
import Collective from "./Collective";
import RajasthanGnaTgna from "./GnaTgna copy";
import ProcurementOverview from "./Overview";
import TrendProcurement from "./TrendAnalysis";

export function DemoRajPowerProcurement() {
  return (
    <NewDynamicTab
      trendTabs={["Trend Analysis"]}
      defaultDates={RuvitalPowerProcurement}
      header="Power Procurement"
      middleComponent={<RuvnlTitle />}
      headerPrefixComponent={<TabSwitcher />}
      tabs={{
        Overview: <ProcurementOverview />,
        "Trend Analysis": <TrendProcurement />,
        Collective: <Collective />,
        "GNA/TGNA": <RajasthanGnaTgna />,
      }}
    />
  );
}
